import {
    createBrowserRouter,
} from 'react-router-dom';

/*** 引入路由界面 ***/
import Error404 from './Error404.js';
import App from '../App.js';
/*** 引入路由界面 ***/

const BasicRouter = createBrowserRouter([
    {
        path: '/',
        element: <App m={11} />,
        errorElement: <Error404 />,
    },
]);

export default BasicRouter